import { Badge } from '@wundo/ui';
import type { ConversationDebugPayload } from '@/lib/conversationDebug.ts';
import { CopyButton } from './CopyButton.tsx';
import { DebugRow, DebugSection } from './DebugSection.tsx';

/** Which conversation this is, whose, and whether it is still going. */
export function IdentitySection({ data }: { data: ConversationDebugPayload }) {
  return (
    <DebugSection title='Identity'>
      <dl>
        <DebugRow label='Conversation ID'>
          <span className='flex items-center gap-2'>
            <code className='rounded-sm bg-fill-faint px-1.5 py-0.5 text-xs'>
              {data.conversation.id}
            </code>
            <CopyButton value={data.conversation.id} label='Copy conversation ID' />
          </span>
        </DebugRow>
        <DebugRow label='Agent'>{data.conversation.agent}</DebugRow>
        <DebugRow label='Channel'>{data.conversation.channel}</DebugRow>
        <DebugRow label='Type'>{data.conversation.type}</DebugRow>
        <DebugRow label='Status'>
          <span className='flex flex-wrap items-center gap-2'>
            {data.is_current && <Badge tone='success'>Current</Badge>}
            {data.conversation.awaiting_action && (
              <Badge tone='warning'>Awaiting action</Badge>
            )}
          </span>
        </DebugRow>
        <DebugRow label='User'>
          {data.user.first_name} {data.user.last_name}{' '}
          <span className='text-ink-muted'>· {data.organisation?.name ?? '—'}</span>
        </DebugRow>
      </dl>
    </DebugSection>
  );
}
